export const isMetaPixelSet = () => Boolean(window.fbq) && window.fbq?.loaded;

export const initMetaPixelTracking = () => {
    if (isMetaPixelSet()) {
        const { pottsalatId } = window.cookie.get();
        fbq("init", reactConfig.meta_pixel, { external_id: pottsalatId });
        fbq("track", "PageView");
    }
};

const trackEvent = (eventName, additionalData) => {
    if (!isMetaPixelSet()) {
        return;
    }

    window.fbq("track", eventName, additionalData);
};

export default {
    trackAddToCartEvent: (additionalData) =>
        trackEvent("AddToCart", additionalData),
    trackCompleteOrderEvent: (additionalData) =>
        trackEvent("Purchase", additionalData),
};
